import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'AdminAddNonprofitOwner',
  description: 'Admin can add an owner to a nonprofit by email.',
  categories: ['Admin'],
  // inline: true,
  props: t.object({
  }),
  todo: [ ],
})
